import React, {useContext}  from 'react';
import {GlobalContext} from '../../Contexts/GlobalContext';

const GlobalBanner = (props)=>{
    
    const {URL} = useContext(GlobalContext);

    const image  = props.image;
    const title = props.title;

    const imgPath = URL + image;


    return(

            <>

                <div className="globalBanner" style={{ backgroundImage:"linear-gradient(to right, rgba(6,22,41,0.83), rgba(6,22,41,0.4)), url("+ imgPath +")" }}>
                
                <h1>
                    {title}
                </h1>

                </div>
            </>

        );

}

export default GlobalBanner